(function () {
  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.from(root.querySelectorAll(selector));
  }

  function tracking(pageSlug) {
    const params = new URLSearchParams(window.location.search);
    if (!params.has("utm_source")) params.set("utm_source", "openai_ads");
    if (!params.has("utm_medium")) params.set("utm_medium", "paid_ai");
    if (!params.has("utm_campaign")) params.set("utm_campaign", "gpt_iced_coffee_cup");
    if (!params.has("utm_content")) params.set("utm_content", pageSlug || "gpt_landing_page");
    return params.toString();
  }

  document.querySelectorAll("[data-gpt-landing]").forEach((root) => {
    const pageSlug = root.dataset.pageSlug || "";
    const quantity = qs(root, "[data-gpt-quantity]");
    const shopifyButton = qs(root, "[data-gpt-buy-shopify]");
    const amazonButton = qs(root, "[data-gpt-buy-amazon]");
    const reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function selectedVariant() {
      return qs(root, "[data-gpt-variant][aria-pressed='true']") || qs(root, "[data-gpt-variant]");
    }

    function selectedQuantity() {
      return Math.max(1, Math.min(9, Number(quantity && quantity.value ? quantity.value : 1)));
    }

    function cartUrl() {
      const variant = selectedVariant();
      const variantId = variant ? variant.dataset.variantId : "";
      if (!variantId) return "";
      return `/cart/${variantId}:${selectedQuantity()}?${tracking(pageSlug)}`;
    }

    function updateShopifyButton() {
      if (!shopifyButton) return;
      const nextUrl = cartUrl();
      if (nextUrl) shopifyButton.href = nextUrl;
    }

    function loadVideo(video, playAfterLoad) {
      if (!video || video.dataset.gptLoaded === "true") return;
      qsa(video, "source[data-src]").forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute("data-src");
      });
      video.dataset.gptLoaded = "true";
      if (video.parentElement) video.parentElement.dataset.loaded = "true";
      video.load();
      if (playAfterLoad && !reducedMotion) {
        video.play().catch(() => {});
      }
    }

    qsa(root, "[data-gpt-variant]").forEach((button) => {
      button.addEventListener("click", () => {
        qsa(root, "[data-gpt-variant]").forEach((item) => item.setAttribute("aria-pressed", "false"));
        button.setAttribute("aria-pressed", "true");
        updateShopifyButton();
      });
    });

    if (quantity) {
      quantity.addEventListener("input", updateShopifyButton);
      quantity.addEventListener("change", updateShopifyButton);
    }

    if (shopifyButton) {
      updateShopifyButton();
      shopifyButton.addEventListener("click", (event) => {
        event.preventDefault();
        const nextUrl = cartUrl();
        if (!nextUrl) return;
        window.location.href = nextUrl;
      });
    }

    if (amazonButton) {
      const url = new URL(amazonButton.href);
      const params = new URLSearchParams(tracking(pageSlug));
      params.forEach((value, key) => {
        if (!url.searchParams.has(key)) url.searchParams.set(key, value);
      });
      amazonButton.href = url.toString();
    }

    const lazyVideos = qsa(root, "[data-gpt-lazy-video]");
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              loadVideo(entry.target, true);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: "0px", threshold: 0.08 }
      );
      lazyVideos.forEach((video) => observer.observe(video));
    } else {
      lazyVideos.forEach((video) => loadVideo(video, false));
    }

    qsa(root, "[data-gpt-video-toggle]").forEach((button) => {
      button.addEventListener("click", () => {
        const video = button.parentElement ? qs(button.parentElement, "video") : null;
        loadVideo(video, true);
      });
    });
  });
})();
